import React, { useState } from "react";
import CoptRight from "../Reuseable/Copyrights";
import { useTranslation } from "react-i18next";
import Footer from "../Reuseable/Footer";
import RaceCourseList from "./RaceCourseList";
import RaceCourseContent from "./RaceCourseContent";
// import "./RaceCourseNew.css"; 

const RaceCourse = () => {
  const { t } = useTranslation();
  const [racecourse, setRacecourse] = useState("option1");

  return (
    <div className="new-racecourse-page">
      {/* 1. Top Banner Section */}
      <div className="new-header-banner">
        <h2>{t("Racecourses Overview")}</h2>
      </div>

      {/* 2. Main Overlapping Content Section */}
      <div className="new-main-content-section">
        <div className="new-grid-container">
          
          {/* Left: About Content */}
          <div className="new-left-about-box">
             <RaceCourseContent racecourse={racecourse} viewMode="about" />
          </div>

          {/* Right: Sidebar Cards */}
          <div className="new-right-sidebar">
             <RaceCourseList setRacecourse={setRacecourse} racecourse={racecourse} />
          </div>
          
        </div>

      </div>
        {/* 3. Bottom Overview Section */}
        <div className="new-bottom-overview">
            <RaceCourseContent racecourse={racecourse} viewMode="overview" />
        </div>

      <Footer />
      <CoptRight />
    </div>
  );
};

export default RaceCourse;